import React from "react"
import { useStaticQuery, graphql } from "gatsby"

import styled from "styled-components"

const Wrapper = styled.div`
  .hero-splat {
    position: absolute;
    z-index: 1;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    @media (max-width: 900px) {
      svg {
        width: 450px;
        height: 450px;
      }
    }
    @media (max-width: 640px) {
      svg {
        width: 420px;
        height: 360px;
      }
    }
  }

  .hero-cup-image {
    position: relative;
    z-index: 10;
  }

  .hero-flair-image {
    &-1,
    &-2 {
      position: absolute;
      z-index: 2;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);

      @media (max-width: 900px) {
        height: 80px;
      }
      @media (max-width: 640px) {
        width: 80px;
        height: auto;
      }
    }

    &-1 {
      transform: translateX(-340px) translateY(14px) rotate(95deg);

      @media (max-width: 900px) {
        transform: translateX(-240px) translateY(14px) rotate(75deg);
      }
      @media (max-width: 640px) {
        transform: translateX(-215px) translateY(-2px) rotate(75deg);
      }
    }
    &-2 {
      transform: translateX(190px) translateY(-95px);

      @media (max-width: 900px) {
        transform: translateX(70px) translateY(25px) rotate(30deg);
      }
      @media (max-width: 640px) {
        transform: translateX(45px) translateY(60px) rotate(30deg);
      }
    }
  }
`

export default function Protein(props) {
  const proteinImages = useStaticQuery(graphql`
    query staticCupSplashProteinImages {
      heroCup: file(relativePath: { eq: "protein/cup.png" }) {
        childImageSharp {
          fluid(maxWidth: 344) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      flair1: file(relativePath: { eq: "protein/flair-01.png" }) {
        childImageSharp {
          fluid(maxWidth: 127) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      flair2: file(relativePath: { eq: "protein/flair-02.png" }) {
        childImageSharp {
          fluid(maxWidth: 134) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)

  return (
    <Wrapper>
      <div className={`hero-splat`}>
        <svg
          width="739px"
          height="803px"
          viewBox="0 0 739 803"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill="#D89559"
            d="M439.095463,3.21608755 C443.347688,1.33599613 448.106374,0.815613682 452.763087,0.929762089 C458.201585,1.06405433 463.731857,2.08131808 468.422562,4.79737873 C476.036458,9.20887895 480.570806,17.6961488 481.869247,26.3177109 C483.167688,34.9426303 481.607519,43.7387723 479.36074,52.1689679 C467.5592,96.435049 436.750111,137.770202 454.632571,184.698627 C464.884139,211.597363 488.388646,235.303302 518.759256,242.42079 C528.072684,244.603039 537.736214,245.217426 547.34536,245.58673 C569.796158,246.452915 593.508008,245.76131 612.807876,235.320088 C639.561885,220.850099 651.190073,191.675109 671.098374,169.939909 C680.622543,159.542332 695.87413,150.128446 709.517961,155.55721 C718.916364,159.300606 723.872195,169.312093 723.396327,178.611831 C722.920458,187.914926 717.988421,196.556632 712.193022,204.241505 C699.004665,221.743142 680.707519,236.045266 659.684327,245.294644 C631.482317,257.703248 596.128684,259.116674 575.673134,280.660507 C557.620721,299.672932 554.867482,329.375019 569.163932,350.855063 C576.5229,361.910672 587.631031,370.565807 595.258524,381.470338 C602.886017,392.374868 606.373454,407.52639 597.66166,417.735958 C593.847914,422.20789 588.06951,425.259681 585.156515,430.255353 C579.517472,439.934466 586.920627,451.59439 586.329191,462.529136 C585.659576,474.967955 574.582036,485.039874 562.508571,490.972234 C550.438505,496.904593 536.859256,500.00003 524.880965,506.083468 C493.375069,522.087747 477.885547,557.023874 479.068421,589.76768 C480.91751,641.097534 512.902674,676.684978 539.908214,716.992795 C546.407219,726.69541 552.535726,736.988911 554.711125,748.420538 C556.889923,759.852165 554.452796,772.740863 545.870167,780.707751 C536.19304,789.691902 520.067895,790.212284 509.024346,782.92693 C489.306392,769.920726 492.528702,738.838786 488.66397,718.409579 C483.585773,691.55113 476.984796,664.810187 465.652327,639.788184 C458.854205,624.781026 449.955463,609.941733 435.794975,600.030965 C421.634486,590.120198 401.178937,586.225723 385.56705,594.14225 C373.840289,600.084682 366.821228,611.267869 358.707669,620.983913 C350.59751,630.699957 339.078092,640.006409 325.682392,639.116723 C311.406336,638.17332 301.130975,625.88558 296.6952,613.540765 C292.259425,601.19595 291.620402,587.840587 286.188702,575.828145 C280.757003,563.812347 269.128815,552.874244 254.832364,553.438271 C232.215012,554.331314 209.349529,563.009951 195.539144,579.289528 C185.566299,591.046814 180.882392,605.782031 172.177397,618.341713 C163.469003,630.898038 147.860515,641.829426 131.94951,638.408331 C113.091519,634.352706 105.616984,611.59017 112.975951,595.324022 C120.334918,579.057874 137.432195,568.351425 154.189566,559.518352 C164.505716,554.079517 175.260346,548.82869 183.197153,540.740939 C202.548008,521.026838 197.887895,486.66481 174.832064,470.559812 C162.585247,462.005396 147.068533,458.43658 133.404308,451.879761 C122.099031,446.450997 111.823669,438.69562 105.756346,428.479338 C99.6890216,418.266413 98.3259981,405.404573 104.050017,395.02714 C113.733942,377.471786 139.131726,372.15717 152.507031,356.720277 C165.86874,341.306885 163.200477,316.476249 146.810205,303.68827 C113.961679,278.061952 63.121923,296.033612 25.2359887,292.602445 C18.3902798,291.984701 11.1468808,290.571275 6.22164131,285.837473 C2.81918122,282.5641 0.902110798,277.988091 0.252890141,273.338222 C-1.74235869,259.005883 8.29166948,244.797763 21.5989934,238.754612 C34.9063174,232.711461 50.5759887,233.688437 64.5257352,238.09658 C78.4754817,242.504723 91.1301859,250.082163 103.880064,257.199652 C134.967876,274.553567 160.491425,276.050926 195.392984,269.779478 C210.552796,267.053345 226.144289,266.224091 239.380233,259.415474 C242.486975,257.817396 245.464552,255.890303 248.272177,253.533474 C264.285153,240.097535 272.109792,214.800233 261.334768,196.647279 C250.981228,179.199359 228.091951,169.516888 212.344101,157.346654 C200.229848,147.986484 191.67781,131.176453 200.811087,119.362092 C209.580665,108.017755 229.675914,109.125666 241.647407,117.72037 C253.223136,126.028583 259.291275,138.901446 265.384613,151.144042 L266.015275,152.408056 C273.649566,167.660298 282.317172,182.482805 291.950111,196.771499 C319.380533,237.451977 369.825998,207.981544 394.577961,180.062187 C429.799031,140.335184 410.223838,79.7391657 420.522993,32.0956347 C423.024702,20.506214 428.147087,8.06068026 439.095463,3.21608755 Z M627.583142,434.17098 C630.567607,432.010697 634.707458,432.409361 638.129825,433.751871 C644.216652,436.133634 649.185147,441.275378 651.40497,447.480227 C654.46691,456.046393 653.537212,463.85612 660.058572,470.602743 C670.423358,481.325785 687.430769,505.521628 667.917215,517.723475 C663.625783,520.405087 658.202545,520.432346 653.230681,519.573685 C649.070619,518.85132 644.833083,517.471328 641.855354,514.44557 C635.404732,507.899983 637.365182,497.176942 637.675081,487.93952 C638.045613,477.03248 635.367679,466.03344 630.03202,456.547279 C628.004201,452.942265 625.568796,449.473547 624.531307,445.459647 C623.497186,441.445747 624.244987,436.583408 627.583142,434.17098 Z M31.2820066,420.058446 C44.403089,417.273528 62.6778634,425.434144 65.1267829,436.938659 C67.5757013,448.443174 51.8597747,452.303495 38.7386971,455.088436 C25.6176103,457.873333 14.4072648,457.436271 11.958345,445.931756 C9.50942688,434.427241 18.1609246,422.843366 31.2820066,420.058446 Z M174.257478,213.111826 C184.205524,207.255451 202.804044,210.132387 213.573885,211.731444 C220.311273,212.732563 224.806193,215.845257 220.650638,224.093384 C217.772692,229.806254 208.423525,235.956473 202.687595,238.184219 C195.238206,241.071405 187.236517,244.085012 179.494343,240.394881 C170.068653,235.901804 162.759002,219.880484 174.257478,213.111826 Z"
          ></path>
        </svg>
      </div>

      <div className={`hero-cup-image`}>
        <img
          alt="Protein Shake!"
          src={proteinImages.heroCup.childImageSharp.fluid.src}
        />
      </div>

      <div className={`hero-flair-image-1`}>
        <img
          alt="Do you have enough flair?"
          src={proteinImages.flair1.childImageSharp.fluid.src}
        />
      </div>

      <div className={`hero-flair-image-2`}>
        <img
          alt="You can never have enough flair!"
          src={proteinImages.flair2.childImageSharp.fluid.src}
        />
      </div>
    </Wrapper>
  )
}
